import { z } from 'zod'
import {
  bioValidator,
  usernameValidator,
  displayNameValidator,
} from '../../validators'

export const createUserSchema = z.object({
  bio: bioValidator,
  username: usernameValidator({ showInlineError: true }),
  displayName: displayNameValidator,
})
